import React, { useEffect, useState } from 'react';
import styles from './PaginationDots.module.scss';
import { usePrevious } from 'Hooks/usePrevious';

export interface IPaginationDotsProps {
  pageCount: number;
  onSelectEvent?: (id: number) => void;
  selectedId: number;
}
const dotSelected: JSX.Element = (
  <div className={`${styles.owl_dot} ${styles.selected}`}>
    <span></span>
  </div>
);

const dot: JSX.Element = (
  <div className={styles.owl_dot}>
    <span></span>
  </div>
);

const dotDeselected: JSX.Element = (
  <div className={`${styles.owl_dot} ${styles.deselected}`}>
    <span></span>
  </div>
);

const generateDots = ({
  pageCount,
  selectedId,
}: {
  pageCount: IPaginationDotsProps['pageCount'];
  selectedId: IPaginationDotsProps['selectedId'];
}) => {
  let arr: Array<JSX.Element> = [];
  for (let i = 0; i < pageCount; i++) {
    if (i == selectedId) {
      arr.push(dotSelected);
    } else {
      arr.push(dot);
    }
  }

  return arr;
};

const PaginationDots = ({ selectedId, pageCount, onSelectEvent }: IPaginationDotsProps) => {
  const [selected, setSelected] = useState(selectedId ?? 0);
  const [dotsArr, setDotsArr] = useState(generateDots({ pageCount, selectedId }));

  const prevPageCount = usePrevious<typeof pageCount>(pageCount);
  const prevSelectedId = usePrevious<typeof selectedId>(selectedId);

  useEffect(() => {
    if (pageCount !== prevPageCount || selectedId != prevSelectedId) {
      const dots = generateDots({ pageCount, selectedId });

      setSelected(prevSelectedId ?? 0);
      setDotsArr(dots);
    }
  }, [pageCount, selectedId]);

  const setAsSelected = (newSelectedId: number) => {
    const temp = [...dotsArr];

    for (let i = 0; i < dotsArr.length; i++) {
      if (i == newSelectedId) {
        temp[i] = dotSelected;
      } else {
        if (i == selected) {
          temp[i] = dotDeselected;
        } else {
          temp[i] = dot;
        }
      }
    }

    setSelected(newSelectedId);
    setDotsArr([...temp]);
    onSelectEvent(newSelectedId);
  };

  return (
    <>
      {pageCount > 1 && (
        <div className={`${styles.owl_dots} d-fl`}>
          {Array.from({ length: dotsArr.length }, (_, i) => {
            return (
              <div key={i} style={{ height: '32px' }} onClick={() => setAsSelected(i)}>
                {dotsArr[i]}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
export default PaginationDots;
